import { gql } from '@apollo/client';
import { TEDUrvalType } from '../../../../../Types/UrvalTypes';

export const getUrvalHitIndicatorQuery = (
  collectionName: string,
  routineID?: number
) => {
  let rtnarg = '';
  if (routineID !== undefined) {
    rtnarg = `, routine: ${routineID}`;
  }
  return gql`
    query urvalHitIndicator($dbName: String!, $urval: [[TEDInputSelectionCondition!]]) {
        db(name: $dbName${rtnarg}) {
            ${collectionName}_Connection(first: 0, selection: $urval) {
            totalCount
            }
        }
    }
    `;
};

export const getdetaljurvalHitIndicatorQuery = (
  collectionName: string,
  associationName: string
) => gql`
query detaljurvalHitIndicator($id: ID!, $urval: [[TEDInputSelectionCondition!]]) {
    node(id: $id) {
      ... on TED${collectionName} {
      id
      _Associations {
        id
        ${associationName}_Connection(selection: $urval) {
          totalCount
        }
      }
      }
    }
}
`;

interface IHitIndicatorConnection {
  totalCount: number;
}

interface IDB {
  [key: string]: IHitIndicatorConnection | null;
}

export interface IUrvalHitIndicatorData {
  db: IDB | null;
}

export interface IUrvalHitIndicatorVariables {
  dbName: string;
  urval?: TEDUrvalType;
}

export interface IDetaljurvalHitIndicatorData {
  node: { id: string; _Associations: IDB | null };
}

export interface IDetaljurvalHitIndicatorVariables {
  id: string;
  urval?: TEDUrvalType;
}
